
import { defineComponent, PropType} from "vue";
import { RoutesDataItem } from '@/utils/routes';
import SiderMenu from './SiderMenu.vue';
export default defineComponent({
    name: 'Left',
    props: {
      collapsed: {
        type: Boolean,
        default: false
      },
      topNavEnable: {
        type: Boolean,
        default: true
      },
      belongTopMenu: {
        type: String,
        default: ''
      },
      selectedKeys: {
        type: Array as PropType<string[]>,
        default: () => {
          return [];
        }
      },
      openKeys: {
        type: Array as PropType<string[]>,
        default: () => {
          return [];
        }
      },
      onOpenChange: {
        type: Function as PropType<(key: any) => void>
      },
      menuData: {
        type: Array as PropType<RoutesDataItem[]>,
        default: () => {
          return [];
        }
      }
    },
    components: {
         SiderMenu,
    },
})
